import {useField, useFormikContext} from "formik"
import React from "react"
import {useTranslation} from 'react-i18next';
import store from "@formApp/store"
import GenericInput from "./fields/GenericInput";

export default () => {
  const {t} = useTranslation();
  const [field, meta, helpers] = useField('invoice');
  const {setFieldValue, touched} = useFormikContext();
  const [isFocus, setFocus] = React.useState(false);
  const [isRequested, setIsRequested] = React.useState(false);
  const {formValues, domainsList, transitions} = React.useContext(store);
  const {Email} = formValues.values;

  const handleChange = async(e) => {
    await field.onChange(e);
    setIsRequested(e.target.checked === true);
  };
  return (
    <>
      <div className={`formGroup${(meta.touched && meta.error) ? ' error' : ''}`}>
        <div className='formField --checkbox'>
          <input {...field} type="checkbox" value="1" defaultChecked={field.value} onChange={handleChange} />
          <label>{t('Richiedi fattura per questo pagamento, non sarà possibile farlo successivamente')} <span>({t('solo per aziende o liberi professionisti')})</span></label>
        </div>
        {meta.touched && meta.error && <div className="errorMessage">{meta.error}</div>}
      </div>
      {isRequested &&
        <div className="invoiceRequest-fields">
          <p>
            {t('La fattura verrà inviata elettronicamente utilizzando l\'indirizzo PEC o il codice destinatrario inserito. In caso di problemi o soggetti stranieri, verrà utilizzato l\'indirizzo email:')}
            <span>{Email}</span>
          </p>
          <p>
            {t('Il codice fiscale della società è richiesto solo per le società sprovviste di partita IVA')}
          </p>
          <section className='formSection halfColumn'>
            <GenericInput name='invoice_rs' label={t('Intestatario della fattura')} span={2} />
            <GenericInput name='invoice_piva' label={t('Partita IVA')} />
            <GenericInput name='invoice_company_cf' label={t('Codice fiscale società')} />
            <GenericInput name='invoice_pec' label={t('Indirizzo PEC')} />
            <GenericInput name='invoice_recipient_code' label={t('Codice destinatario SdI')} />
            <GenericInput name='invoice_addr' label={t('Indirizzo')} />
            <GenericInput name='invoice_cap' label={t('CAP')} />
            <GenericInput name='invoice_city' label={t('Città')} />
            <GenericInput name='invoice_prov' label={t('Provincia/Stato')} />
            <GenericInput name='invoice_name' label={t('Nome')} />
            <GenericInput name='invoice_surname' label={t('Cognome')} />
            <GenericInput name='invoice_cf' label={t('Codice fiscale')} />
            <GenericInput name='invoice_tel' label={t('Telefono')} />
          </section>
        </div>
      }
    </>
  )
}

